var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 488.8 488.8",
    style: {
      enableBackground: "new 0 0 488.8 488.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d1d1d"
    },
    d: "M488.8,383V9.9c0-5.5-4.4-9.9-9.9-9.9H105.8c-5.5,0-9.9,4.4-9.9,9.9V383c0,5.5,4.4,9.9,9.9,9.9 h373.1C484.4,392.9,488.8,388.5,488.8,383z M469,373.1H115.7V19.8H469V373.1L469,373.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d1d1d"
    },
    d: "M9.9,488.8H383c5.5,0,9.9-4.4,9.9-9.9s-4.4-9.9-9.9-9.9H19.8V105.8c0-5.5-4.4-9.9-9.9-9.9 S0,100.3,0,105.8v373.1C0,484.4,4.4,488.8,9.9,488.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4b536"
    },
    d: "M211.8,206.3h70.7V277c0,5.5,4.4,9.9,9.9,9.9s9.9-4.4,9.9-9.9v-70.7H373c5.5,0,9.9-4.4,9.9-9.9 s-4.4-9.9-9.9-9.9h-70.7v-70.7c0-5.5-4.4-9.9-9.9-9.9s-9.9,4.4-9.9,9.9v70.7h-70.7c-5.5,0-9.9,4.4-9.9,9.9 S206.3,206.3,211.8,206.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.1d2e73770454c4e0451f024cf158d44e.svg";
export { ForwardRef as ReactComponent };